interface LayoutProps {
  children: React.ReactNode;
}

export const Container: React.FC<LayoutProps> = ({ children }) => {
  return <main className="flex-1 overflow-y-auto">{children}</main>;
};
